import { render } from "./ModalDocumentAgreement.vue?vue&type=template&id=0fc36729&scoped=true"
import script from "./ModalDocumentAgreement.vue?vue&type=script&lang=js"
export * from "./ModalDocumentAgreement.vue?vue&type=script&lang=js"

import "./ModalDocumentAgreement.vue?vue&type=style&index=0&id=0fc36729&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0fc36729"]])

export default __exports__